import Home from "./Home";
import {Routes,Route} from 'react-router-dom'
import React from 'react'
import PlayersPage from "./PlayersPage";
import LeaguesPage from "./LeaguesPage";
import TeamsPage from "./TeamsPage";
import PlayersCard from "../components/PlayersCard";
import TeamsCard from "../components/TeamsCard";

function Pages() {
  return (
    <div>
     <Routes>
        <Route path="/" element={<Home/>}  />
        <Route path="/players" element={<PlayersPage />} />
        <Route path="/players/card/:id" element={<PlayersCard />} />
        <Route path="/teams" element={<TeamsPage />} />
        <Route path="/leagues" element={<LeaguesPage />} />
        <Route path="/teams/:idleague/:id" element={<TeamsCard/>} />
      </Routes>
    </div>
  )
}

export default Pages
